export default "/images/vendor/flag-icon-css/flags/4x3/gb-wls.svg?a69b6bb076d89808e06433d79c9d3d6d";